import React from 'react';
import { motion } from 'framer-motion';
import { Search, EyeOff, ShoppingCart } from 'lucide-react';
export const Pain = () => {
  return <section className="relative py-32 bg-background overflow-hidden" data-id="element-142">
      {/* Subtle fog effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/[0.03] via-background to-background pointer-events-none" data-id="element-143" />

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-144">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: -50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-145">
          Mientras leés esto, alguien está buscando lo que vos ofrecés.
        </motion.h2>
        <motion.p className="text-xl md:text-3xl text-text-secondary mb-20 font-serif italic" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.8
      }} data-id="element-146">
          Y se lo está comprando a tu competencia.
        </motion.p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-12 md:gap-20 mb-24" data-id="element-147">
          {[{
          icon: Search,
          text: 'Buscaron en Google',
          delay: 0
        }, {
          icon: EyeOff,
          text: 'No te encontraron',
          delay: 0.4
        }, {
          icon: ShoppingCart,
          text: 'Compraron en otro lado',
          delay: 0.8
        }].map((item, index) => <motion.div key={index} className="flex flex-col items-center" initial={{
          opacity: 0,
          x: index === 0 ? -50 : index === 2 ? 50 : 0,
          y: index === 1 ? 50 : 0
        }} whileInView={{
          opacity: 1,
          x: 0,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: item.delay,
          duration: 0.6,
          type: 'spring'
        }} data-id="element-148">
              <motion.div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mb-6 text-red-500" whileInView={{
            rotate: [0, -10, 10, -10, 10, 0]
          }} viewport={{
            once: true
          }} transition={{
            delay: item.delay + 0.5,
            duration: 0.5
          }} data-id="element-149">
                <item.icon size={40} data-id="element-150" />
              </motion.div>
              <p className="text-lg font-medium text-text-secondary" data-id="element-151">
                ❌ {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-152">
          <motion.p className="text-red-500 font-bold text-xl md:text-2xl mb-12 tracking-widest uppercase" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-153">
            Esto pasa hoy. Mañana. Todos los días.
          </motion.p>

          <div className="inline-block relative" data-id="element-154">
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-155">
              El problema no es tu producto.
            </h3>
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-primary relative inline-block" data-id="element-156">
              El problema es que no te ven.
              <motion.svg className="absolute -bottom-2 left-0 w-full h-3 text-primary" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-157">
                <motion.path d="M0 5 Q 50 10 100 5" fill="transparent" stroke="currentColor" strokeWidth="3" initial={{
                pathLength: 0
              }} whileInView={{
                pathLength: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 1,
                delay: 0.5,
                ease: 'easeInOut'
              }} data-id="element-158" />
              </motion.svg>
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
};